module.exports = __webpack_public_path__ + "static/img/logo.5d06ad9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 4Uwr
// module chunks = 1